export interface FMFModels {
	id: number
	name: string
}
